import { AxiosResponse } from "axios";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";

import { SelectOption } from "dto/components/app-select-input-dto";
import ErrorResponseDto from "dto/services/error-response-dto";

const getClientPlatform = async (): Promise<AxiosResponse<{ content: SelectOption[] }>> => {
	let response = null;

	let errorMessage = "";

	const capitalizeFirstLetter = (str: string): string => {
		if (!str) return str;
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	};

	try {
		const res = await api.get.client.clientPlatform();

		const content = res.data.data.map((o: string) => ({
			label: capitalizeFirstLetter(o),
			value: o,
		}));

		response = { ...res, data: { ...res.data, content: content } };
	} catch (error) {
		const err = error as Error | ErrorResponseDto;
		serveRequestErrors(err);
	}

	if (response) return response;

	throw errorMessage;
};

export default getClientPlatform;
